//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from "vuex";
import WarehouseSettingsWidget from "../../Widgets/WarehouseSettingsWidget.vue";
import logger from "@/utils/logger";

const WAREHOUSE_ASSISTANT_SETTING_KEY = {
  WA_Order_CopyDepartmentFromOrderHeadToOrderLines:
    "WA_Order_CopyDepartmentFromOrderHeadToOrderLines",
  WA_Order_MarkOrderLinesWithDepartmentBasedOnWarehousePriority:
    "WA_Order_MarkOrderLinesWithDepartmentBasedOnWarehousePriority",
  WA_Order_MarkOrderLinesWithDepartmentBasedOnWarehousePriority_SelectNextIfOutOfStock:
    "WA_Order_MarkOrderLinesWithDepartmentBasedOnWarehousePriority_SelectNextIfOutOfStock",
  WA_Order_MarkOrderLinesWithDepartmentBasedOnWarehousePriority_AllowExtWarehouse:
    "WA_Order_MarkOrderLinesWithDepartmentBasedOnWarehousePriority_AllowExtWarehouse",
  WA_Order_SetWebOrderToReadyForInvoicing:
    "WA_Order_SetWebOrderToReadyForInvoicing",
  WA_Order_SetWebOrderToDropshipping: "WA_Order_SetWebOrderToDropshipping",
  WA_Dropshipping_UseOrderDeliveryAddressOnPurchaseOrderIfExtWarehouse:
    "WA_Dropshipping_UseOrderDeliveryAddressOnPurchaseOrderIfExtWarehouse",
  WA_Dropshipping_CarryOutDeliveryByAgreedPurchase:
    "WA_Dropshipping_CarryOutDeliveryByAgreedPurchase",
  WA_Dropshipping_CarryOutDeliveryBySentOrder:
    "WA_Dropshipping_CarryOutDeliveryBySentOrder",
  WA_Purchase_FindBestSupplierPerLineDP:
    "WA_Purchase_FindBestSupplierPerLineDP",
  WA_Purchase_FindBestSupplierPerLineDP_ChooseFrom:
    "WA_Purchase_FindBestSupplierPerLineDP_ChooseFrom",
  WA_Purchase_AllLinesFromOneSupplier: "WA_Purchase_AllLinesFromOneSupplier"
};

const FIND_BEST_SUPPLIER_PER_LINE_CHOOSE_FROM_VALUES = {
  priority: 1,
  lowestPrice: 2
};

export default {
  components: { WarehouseSettingsWidget },
  setup() {
    return {};
  },
  data() {
    return {
      priceOptions: [
        { id: 0, desc: 'innpris' },
        { id: 1, desc: 'veiet innpris' },
        { id: 2, desc: 'selvkost' }
      ],
      
      savedisabled: false,
      compSettingsTab: "settings",
      usrSettingsTab: "settings",
      shippingOptions: [
        {
          id: 0,
          desc: "Ikke valgt"
        },
        {
          id: 1,
          desc: "Consignor"
        },
        {
          id: 2,
          desc: "Axia"
        }
      ],
      UserSettings: [],
      CompanySettings: [],
      integrationSettings: {},
      AccountTypes: [],
      row: {},
      freight: {},
      warehouseAssistant: {},
      consignor: false,
      toggleFreightPercent: false,
      toggleFreightValue: false,
      selectedShippingCompany: "",
      wa_Purchase_SupplierSelectedOption: null,
      wa_Purchase_FindBestSupplierPerLineDP_ChooseFromOptions: [
        {
          label: "Velg ut fra prioritet",
          value: FIND_BEST_SUPPLIER_PER_LINE_CHOOSE_FROM_VALUES.priority
        },
        {
          label: "Velg laveste pris",
          value: FIND_BEST_SUPPLIER_PER_LINE_CHOOSE_FROM_VALUES.lowestPrice
        }
      ],
      wa_Purchase_FindBestSupplierPerLineDP_ChooseFromSelectedOption: null
    };
  },

  mounted() {
    this.CompanySettings = this.companySettings.filter(
      setting => !this.isWarehouseAssistantSetting(setting) && !this.isIntegrationSetting(setting)
    );
    this.warehouseAssistant = this.buildWarehouseAssistantObj();
    this.integrationSettings = this.buildIntegrationObject();

    logger.log(this.integrationSettings);

    this.wa_Purchase_SupplierSelectedOption = this.companySettings.find(
      setting =>
        [
          WAREHOUSE_ASSISTANT_SETTING_KEY.WA_Purchase_FindBestSupplierPerLineDP,
          WAREHOUSE_ASSISTANT_SETTING_KEY.WA_Purchase_AllLinesFromOneSupplier
        ].includes(setting.settingName) &&
        setting.isBoolValue &&
        setting.boolValue
    )?.settingName;
    this.wa_Purchase_FindBestSupplierPerLineDP_ChooseFromSelectedOption = this.companySettings.find(
      setting =>
        setting.settingName ===
        WAREHOUSE_ASSISTANT_SETTING_KEY.WA_Purchase_FindBestSupplierPerLineDP_ChooseFrom
    )?.intValue;
    this.UserSettings = this.userSettings;


    this.getAccountTypes();
  },

  computed: {
    ...mapState("main", [
      "userSettings",
      "companySettings",
      "suppliers",
      "warehouses"
    ]),

    warehouseAssistantToBeWatched() {
      return { ...this.warehouseAssistant };
    }
  },

  watch: {
    // toggleFreightPercent(newValue, oldValue) {
    //   if (newValue != oldValue) {
    //     this.toggleFreightValue = false;
    //   }
    // },
    // toggleFreightValue(newValue, oldValue) {
    //   if (newValue != oldValue) {
    //     this.toggleFreightPercent = false;
    //   }
    // },
    warehouseAssistantToBeWatched: {
      handler(newValue, oldValue) {
        const settings = WAREHOUSE_ASSISTANT_SETTING_KEY;

        const handleToggle = (key1, key2) => {
          if (newValue[key1] !== oldValue[key1] && newValue[key1]) {
            this.warehouseAssistant[key2] = false;
            return;
          }

          if (newValue[key2] !== oldValue[key2] && newValue[key2]) {
            this.warehouseAssistant[key1] = false;
          }
        };

        handleToggle(
          settings.WA_Dropshipping_CarryOutDeliveryByAgreedPurchase,
          settings.WA_Dropshipping_CarryOutDeliveryBySentOrder
        );

        handleToggle(
          settings.WA_Purchase_FindBestSupplierPerLineDP,
          settings.WA_Purchase_AllLinesFromOneSupplier
        );
      },
      deep: true
    },

    wa_Purchase_SupplierSelectedOption(newValue) {
      switch (newValue) {
        case WAREHOUSE_ASSISTANT_SETTING_KEY.WA_Purchase_FindBestSupplierPerLineDP:
          this.warehouseAssistant[
            WAREHOUSE_ASSISTANT_SETTING_KEY.WA_Purchase_FindBestSupplierPerLineDP
          ] = true;
          this.warehouseAssistant[
            WAREHOUSE_ASSISTANT_SETTING_KEY.WA_Purchase_AllLinesFromOneSupplier
          ] = false;
          break;
        case WAREHOUSE_ASSISTANT_SETTING_KEY.WA_Purchase_AllLinesFromOneSupplier:
          this.warehouseAssistant[
            WAREHOUSE_ASSISTANT_SETTING_KEY.WA_Purchase_FindBestSupplierPerLineDP
          ] = false;
          this.warehouseAssistant[
            WAREHOUSE_ASSISTANT_SETTING_KEY.WA_Purchase_AllLinesFromOneSupplier
          ] = true;
          break;
      }
    },
    wa_Purchase_FindBestSupplierPerLineDP_ChooseFromSelectedOption(newValue) {
      this.warehouseAssistant[
        WAREHOUSE_ASSISTANT_SETTING_KEY.WA_Purchase_FindBestSupplierPerLineDP_ChooseFrom
      ] = newValue;
    }
  },

  methods: {
    ...mapActions("main", ["getAccount"]),


    isWarehouseAssistantSetting(setting) {
      if (setting == null) {
        throw new Error("Setting can't be null or undefined");
      }

      switch (setting.settingName) {
        case WAREHOUSE_ASSISTANT_SETTING_KEY.WA_Order_CopyDepartmentFromOrderHeadToOrderLines:
        case WAREHOUSE_ASSISTANT_SETTING_KEY.WA_Order_MarkOrderLinesWithDepartmentBasedOnWarehousePriority:
        case WAREHOUSE_ASSISTANT_SETTING_KEY.WA_Order_MarkOrderLinesWithDepartmentBasedOnWarehousePriority_SelectNextIfOutOfStock:
        case WAREHOUSE_ASSISTANT_SETTING_KEY.WA_Order_MarkOrderLinesWithDepartmentBasedOnWarehousePriority_AllowExtWarehouse:
        case WAREHOUSE_ASSISTANT_SETTING_KEY.WA_Order_SetWebOrderToReadyForInvoicing:
        case WAREHOUSE_ASSISTANT_SETTING_KEY.WA_Order_SetWebOrderToDropshipping:
        case WAREHOUSE_ASSISTANT_SETTING_KEY.WA_Dropshipping_UseOrderDeliveryAddressOnPurchaseOrderIfExtWarehouse:
        case WAREHOUSE_ASSISTANT_SETTING_KEY.WA_Dropshipping_CarryOutDeliveryByAgreedPurchase:
        case WAREHOUSE_ASSISTANT_SETTING_KEY.WA_Dropshipping_CarryOutDeliveryBySentOrder:
        case WAREHOUSE_ASSISTANT_SETTING_KEY.WA_Purchase_FindBestSupplierPerLineDP:
        case WAREHOUSE_ASSISTANT_SETTING_KEY.WA_Purchase_FindBestSupplierPerLineDP_ChooseFrom:
        case WAREHOUSE_ASSISTANT_SETTING_KEY.WA_Purchase_AllLinesFromOneSupplier:
          return true;
        default:
          return false;
      }
    },

    async getAccountTypes() {
      this.AccountTypes = await this.getAccount();
    },

    handleToggleFreightPercent(newValue) {
      this.toggleFreightPercent = newValue;
      if (newValue) {
        this.toggleFreightValue = false;
      }
    },
    handleToggleFreightValue(newValue) {
      this.toggleFreightValue = newValue;
      if (newValue) {
        this.toggleFreightPercent = false;
      }
    },

    buildWarehouseAssistantObj() {
      return this.companySettings.reduce((acc, curr) => {
        if (!this.isWarehouseAssistantSetting(curr)) {
          return acc;
        }

        if (curr.isIntValue) {
          acc[curr.settingName] = curr.intValue;
        }

        if (curr.isStringValue) {
          acc[curr.settingName] = curr.stringValue;
        }

        if (curr.isBoolValue) {
          acc[curr.settingName] = curr.boolValue;
        }

        return acc;
      }, {});
    },

    buildWarehouseAssistantSettings() {
      return this.companySettings.reduce((acc, curr) => {
        if (!this.isWarehouseAssistantSetting(curr)) {
          return acc;
        }

        var val = this.warehouseAssistant[curr.settingName];

        if (curr.isIntValue) {
          curr.intValue = val;
        }

        if (curr.isStringValue) {
          curr.stringValue = val;
        }

        if (curr.isBoolValue) {
          curr.boolValue = val;
        }

        acc.push(curr);
        return acc;
      }, []);
    },

    isIntegrationSetting(setting) {
      if(setting == null) {
        throw new Error("Setting can't be null")
      }

      switch(setting.settingName) {
        case "EbridgeClientId":
        case "EbridgeClientSecret":
          return true;
        default:
          return false;
      }
    },

    buildIntegrationObject() {
      return this.companySettings.reduce((acc, curr) => {
        if(!this.isIntegrationSetting(curr)) {
          return acc;
        }

        if (curr.isIntValue) {
          acc[curr.settingName] = curr.intValue;
        }

        if (curr.isStringValue) {
          acc[curr.settingName] = curr.stringValue;
        }

        if (curr.isBoolValue) {
          acc[curr.settingName] = curr.boolValue;
        }

        return acc;
      }, {})
    },

    buildIntegrationSettings() {
      return this.companySettings.reduce((acc, curr) => {
        if (!this.isIntegrationSetting(curr)) {
          return acc;
        }

        var val = this.integrationSettings[curr.settingName];

        if (curr.isIntValue) {
          curr.intValue = val;
        }

        if (curr.isStringValue) {
          curr.stringValue = val;
        }

        if (curr.isBoolValue) {
          curr.boolValue = val;
        }

        acc.push(curr);
        return acc;
      }, []);
    },

    async saveSettings() {
      this.savedisabled = true;

      var combinedSettings = [
        ...this.buildIntegrationSettings(),
        ...this.buildWarehouseAssistantSettings(),
        ...this.UserSettings,
        ...this.CompanySettings
      ];
      var settingsToSave = [];

      combinedSettings.forEach(setting => {
        var putSetting = {};
        putSetting.settingTypeId = setting.settingTypeId;
        putSetting.intValue = parseInt(setting.intValue);
        putSetting.stringValue = setting.stringValue;
        putSetting.boolValue = setting.boolValue;
        settingsToSave.push(putSetting);
      });

      await this.updateSettings(settingsToSave);
      await this.createOrUpdateConsignor();
      this.savedisabled = false;
    },

    async setLocation() {
      this.LocationsWithQuantity = await this.getLocationsWithQuantity();
    },

    async lockLocation(row) {
      var putObject = {};
      putObject["id"] = row.id;
      putObject["isDeleted"] = !row.isDeleted;
      putObject["locationGroupName"] = row.locationGroupName;
      putObject["locationName"] = row.locationName;
      putObject["quantity"] = row.quantity;
      putObject["warehouseId"] = row.warehouseId;
      putObject["warehouseName"] = row.warehouseId;

      await this.putLocation(putObject);
      this.LocationsWithQuantity = await this.getLocationsWithQuantity();
    },

    async createOrUpdateConsignor() {
      if (this.toggleFreightPercent) {
        this.freight.additionalPrice = 0;
      }
      if (this.toggleFreightValue) {
        this.freight.additionalPercent = 0;
      }
      if (!this.toggleFreightPercent && !this.toggleFreightValue) {
        this.freight.additionalPercent = 0;
        this.freight.additionalPrice = 0;
      }

      if (this.freight.id == 0) {
        //create

        this.freight = await this.postConsignor(this.freight);
      } else {
        this.freight = await this.putConsignor(this.freight);
      }
    },

    ShippingCompanyChanged(value) {
      this.freight.clientType = value;
      if (value == 0) {
        this.freight.enabled = false;
      } else {
        this.freight.enabled = true;
      }
    },

    ...mapActions("main", [
      "getSettings",
      "updateSettings",
      "getConsignor",
      "postConsignor",
      "putConsignor",
      "getWarehouse"
    ])
  },

  async created() {
    this.freight = await this.getConsignor();
    if (this.freight.additionalPrice > 0) {
      this.toggleFreightValue = true;
    }
    if (this.freight.additionalPercent > 0) {
      this.toggleFreightPercent = true;
    }

    this.selectedShippingCompany = this.freight.clientType;
  }
};
